function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { createEditorPlatformManifestServicesError, EditorPlatformManifestServicesErrorCode } from './errors';
var _loadManifestsCache = /*#__PURE__*/new WeakMap();
var _ManifestLoader_brand = /*#__PURE__*/new WeakSet();
export class ManifestLoader {
  constructor(manifestUrlResolver) {
    this.manifestUrlResolver = manifestUrlResolver;
    _classPrivateMethodInitSpec(this, _ManifestLoader_brand);
    _classPrivateFieldInitSpec(this, _loadManifestsCache, new Map());
  }
  async load(compType) {
    return _assertClassBrand(_ManifestLoader_brand, this, _load).call(this, compType);
  }
}
async function _load(compType) {
  const url = this.manifestUrlResolver.getManifestUrlByCompType(compType);
  if (!url) {
    throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ManifestUrlNotProvided, compType);
  }
  const cached = _classPrivateFieldGet(_loadManifestsCache, this).get(url);
  if (cached) {
    return cached;
  }
  const loadManifestPromise = _assertClassBrand(_ManifestLoader_brand, this, _loadFromCDN).call(this, url);
  _classPrivateFieldGet(_loadManifestsCache, this).set(url, loadManifestPromise);
  loadManifestPromise.finally(() => {
    _classPrivateFieldGet(_loadManifestsCache, this).delete(url);
  });
  return loadManifestPromise;
}
async function _loadFromCDN(url) {
  try {
    const response = await fetch(url, {
      headers: {
        'x-wix-extended-timeout': '1'
      }
    });
    return await response.json();
  } catch (e) {
    throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.LoadManifestFromCDNError, url).withParentError(e);
  }
}
//# sourceMappingURL=ManifestLoader.js.map